<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1">
      <div>
        <el-input clearable class="input-m" placeholder="商品分类名称" v-model="params.category_name" @change="searchList"></el-input>
        <el-input clearable class="input-m" placeholder="活动名称" v-model="params.activity_title" @change="searchList"></el-input>
        <el-input clearable class="input-m" placeholder="报名序号" v-model="params.sign_in_code" @change="searchList"></el-input>
        <el-button class="btn_input" @click="onDialog('shop')">{{ shop_num }} <i
            class="el-icon-circle-plus icon"></i></el-button>
        <el-button v-if="login_type != 'distributor'" class="btn_input" @click="onDialog('sgency')">{{ agency_num }} <i
            class="el-icon-circle-plus icon"></i></el-button>
        <el-date-picker @change="searchList" v-model="params.created" value-format="timestamp" type="datetimerange"
                        :default-time="['00:00:00', '23:59:59']" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary" @click="searchList">查询</el-button>
        <el-button type="primary" @click="exportData">导出</el-button>
      </div>

      <el-table :data="list" style="width: 100%" :height="wheight - 190" v-loading="loading"
        element-loading-text="数据加载中">
        <el-table-column prop="id" width="60" label="编号"></el-table-column>
        <el-table-column prop="category_name" label="搭售商品分类">
          <template slot-scope="scope">
            {{scope.row.category_name}}
            <el-tag size="mini" type="danger" v-if="scope.row.cancel_status == 1">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="activity_title" label="活动"></el-table-column>
        <el-table-column prop="sign_in_code" label="报名序号"></el-table-column>
        <el-table-column prop="gifts_issue_name" label="发放礼品"></el-table-column>
        <el-table-column prop="name" label="门店名称">
          <template slot-scope="scope">
            <span>{{ scope.row.distributor_info.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="门店AppleID" width="140px">
          <template slot-scope="scope">
            <span>{{ scope.row.distributor_info.shop_code }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="所属经销商">
          <template slot-scope="scope">
            <span>{{ scope.row.distributor_info.dealer_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_fee" width="200" label="创建时间">
          <template slot-scope="scope">
            <div>
              <template>
                {{ scope.row.created | datetime("yyyy-MM-dd hh:mm:ss") }}
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="content-padded content-center">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="params.page" :total='total_count' :page-size="params.page_size">
        </el-pagination>
      </div>
    </div>
    <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :relDataIds="distributor_info"
      :get-status="setDistributorStatus" @chooseStore="chooseDistributorAction" @closeStoreDialog="closeDialogAction"
      returnType="selectRow"></DistributorSelect>
    <DealerSelect :store-visible="DealerVisible" :is-valid="isValid" :rel-data-ids="relDealers"
      :get-status="DealerStatus" @chooseStore="DealerChooseAction" @closeStoreDialog="closeDialogAction"
      :isSingleSelect="isSingleSelect"></DealerSelect>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DistributorSelect from '@/components/function/distributorSelect'
import DealerSelect from '@/components/function/dealerSelect'
import {
  getOfflineActivityRelationSaleLogList
} from '@/api/promotions'

export default {
  provide() {
    return {
    }
  },
  components: {
    DistributorSelect,
    DealerSelect,
  },
  data() {
    return {
      distributorLoading: false,
      distributorVisible: false,
      DealerVisible: false,
      isValid: true,
      relDealers: [],
      DealerStatus: false,
      loading: false,
      params: {
        page: 1,
        page_size: 20,
        created: [],
        distributor_ids: [],
        dealer_ids: [],
        activity_title: '',
        category_name: '',
        sign_in_code: '',
      },
      total_count: 0,
      list: [],
      distributor_info: [],
      selectedDistributors: [],
      setDistributorStatus: false,
      shop_num: '归属店铺',
      agency_num: '归属经销商',
      dialog_type: 1,
      rolesListData: []
    }
  },
  computed: {
    ...mapGetters([
      'wheight',
      'login_type'
    ]),
    isSingleSelect() {
      const role = this.rolesListData.find(item => item.role_id === this.form.role_id)
      return role && role.role_name !== 'VAD_Admin'
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.params.page = val
      this.loading = false
      this.getList()
    },
    handleSizeChange(pageSize) {
      this.params.page = 1
      this.params.page_size = pageSize
      this.getList()
    },
    dateStrToTimeStamp(str) {
      return Date.parse(new Date(str)) / 1000
    },
    searchList () {
      this.params.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      let filter = {
        ...this.params,
      }
      getOfflineActivityRelationSaleLogList(filter).then(response => {
        this.list = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      }).catch(error => {
        this.list = []
        this.total_count = 0
        this.loading = false
      })
    },
    onDialog(type) {
      if (type == 'shop') {
        this.dialog_type = 1
        this.distributorVisible = true
      } else {
        this.dialog_type = 2
        this.DealerVisible = true
        this.DealerStatus = true
      }
    },
    chooseDistributorAction(val) {
      this.distributor_info = val
      let arr = []
      val.forEach(i => {
        arr.push(i.distributor_id)
      });
      this.params.distributor_ids = arr.join(',')
      if (val.length > 0) {
        this.shop_num = `已选择${val.length}门店`
      } else {
        this.shop_num = '归属店铺'
      }
      this.closeDialogAction()
    },
    DealerChooseAction(val) {
      this.relDealers = val
      let arr = []
      val.forEach(i => {
        arr.push(i.dealer_id)
      });
      this.params.dealer_ids = arr.join(',')
      if (val.length > 0) {
        this.agency_num = `已选中${val.length}个经销商`
      } else {
        this.agency_num = '归属经销商'
      }
      this.closeDialogAction()
    },
    closeDialogAction() {
      if (this.dialog_type == 1) {
        this.distributorVisible = false
      } else {
        this.DealerStatus = false
        this.DealerVisible = false
      }
    },
    exportData () {
      let filter = {
        ...this.params,
        is_export: 1
      }
      getOfflineActivityRelationSaleLogList(filter).then(response => {
        this.$message.success('导出成功')
      }).catch(error => {
        this.loading = false
      })
    },
    initDate() {
      // 默认时间为一个月前到现在
      const end = new Date();
      const start = new Date();
      start.setMonth(start.getMonth() - 1); // 一个月前
      
      // 设置开始时间为00:00:00，结束时间为23:59:59
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      
      this.params.created = [start.getTime(), end.getTime()];
    },
  },
  mounted() {
    this.initDate();
    this.getList()
  },
  watch: {
    '$route'() {
      this.getList()
    }
  },
}
</script>

<style lang="scss" scoped>
.btn_input {
  .el-icon-circle-plus {
    margin-left: 20px !important;
  }
}

.pagination {
  margin-top: 10px
}
</style>
